var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.log
    ? _c(
        "div",
        { staticClass: "asta-log", class: _vm.effect },
        [
          _c(
            "v-icon",
            {
              attrs: {
                "x-small": _vm.xSmall,
                small: _vm.small,
                color: _vm.color,
              },
            },
            [_vm._v(_vm._s(_vm.icon))]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "ml-1",
            domProps: { innerHTML: _vm._s(_vm.testo) },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }